import { useEffect } from 'react';
import { Hero } from '../components/Hero';

export function Landing() {
  useEffect(() => {
    document.title = 'The Arena';
  }, []);

  return <Hero />;
}
